import {ChipsField, IChipsFieldProps} from "./ChipsField";
import React from "react";

export interface IMailAddressFieldProps {
	readonly fractionDigits?: number;
	readonly onValueChange?: (values: string[] | null) => void;
	label: string;
	options: IMailAddress[];
	value?: string[];
	grouped?: boolean;
	endAdornment?: React.ReactNode;
}

export interface IMailAddress {
	group?: string;
	name: string;
	mail: string;
	
}

export function MailAddressField(props: IMailAddressFieldProps ) {
	const chipProps: IChipsFieldProps<IMailAddress> = {
		label: props.label,
		options: props.options,
		optionValue: option => typeof option === "string" ? option : option.mail,
		optionLabel: option => typeof option === "string" ? option : option.name + "(" + option.mail + ")",
		value: props.value??[],
		onValueChange: props.onValueChange,
		groupBy: option => option.group??"",//props.grouped ?  option => option.group??"": undefined,
		endAdornment: props.endAdornment
	};
	return <ChipsField
		{...chipProps}
	/>;

}
